const CONSENT_KEY = 'plevits_cookie_consent';
const DNT_DISMISSED_KEY = 'plevits_dnt_banner_dismissed';

export type ConsentStatus = 'granted' | 'denied' | 'undecided';

export function getConsentStatus(): ConsentStatus {
  const stored = localStorage.getItem(CONSENT_KEY);
  if (stored === 'granted' || stored === 'denied') return stored;
  return 'undecided';
}

export function setConsentStatus(status: 'granted' | 'denied'): void {
  localStorage.setItem(CONSENT_KEY, status);
  window.dispatchEvent(
    new CustomEvent('plevits:consent-change', { detail: status })
  );
}

export function resetConsentStatus(): void {
  localStorage.removeItem(CONSENT_KEY);
  window.dispatchEvent(
    new CustomEvent('plevits:consent-change', { detail: 'denied' })
  );
}

export function isDntEnabled(): boolean {
  return navigator.doNotTrack === '1';
}

export function isDntBannerDismissed(): boolean {
  return localStorage.getItem(DNT_DISMISSED_KEY) === 'true';
}

export function dismissDntBanner(): void {
  localStorage.setItem(DNT_DISMISSED_KEY, 'true');
}

export function resetDntBanner(): void {
  localStorage.removeItem(DNT_DISMISSED_KEY);
}
